import difference from 'lodash/difference';
import isEqual from 'lodash/isEqual';
import keys from 'lodash/keys';
import pickBy from 'lodash/pickBy';
import uniq from 'lodash/uniq';

/**
 * Returns unique keys that differ between two objects.
 * - Same key but different value
 * - Missing from A
 * - Missing from B
 */
export const jsonKeysWithDifferentValues = <T extends Record<string, unknown>>(
  objA: T,
  objB: T
): string[] => {
  return uniq([
    ...keys(pickBy(objA, (val, key) => !isEqual(val, objB[key as keyof T]))),
    ...difference(keys(objB), keys(objA)),
    ...difference(keys(objA), keys(objB)),
  ]);
};
